




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderItem } from '@/models/order/OrderItem';

@Component
export default class SumPanel extends Vue {
    @Prop({ required: true })
    public order!: OrderItem;

    get totalExclVat () {
        return this.total * 0.85;
    }

    get total () {
        return this.order.raw_cart_data.total;
    }

    get vat () {
        return this.total * 0.25;
    }
}
